import {
  SMVM_GET_PRIVATE_NOTE_FAIL,
  SMVM_GET_PRIVATE_NOTE_REQUEST,
  SMVM_GET_PRIVATE_NOTE_RESET,
  SMVM_GET_PRIVATE_NOTE_SUCCESS,
  SMVM_SET_PRIVATE_NOTE_FAIL,
  SMVM_SET_PRIVATE_NOTE_REQUEST,
  SMVM_SET_PRIVATE_NOTE_RESET,
  SMVM_SET_PRIVATE_NOTE_SUCCESS,
} from "../constants/privateNoteConstants";

export const smvm_set_privatenote_reducers = (state = { data: {} }, action) => {
  switch (action.type) {
    case SMVM_SET_PRIVATE_NOTE_REQUEST:
      return { loading: true };
    case SMVM_SET_PRIVATE_NOTE_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case SMVM_SET_PRIVATE_NOTE_FAIL:
      return { loading: false, error: action.payload };
    case SMVM_SET_PRIVATE_NOTE_RESET:
      return {};
    default:
      return state;
  }
};

export const smvm_get_privatenote_reducers = (state = { data: {} }, action) => {
  switch (action.type) {
    case SMVM_GET_PRIVATE_NOTE_REQUEST:
      return { loading: true };
    case SMVM_GET_PRIVATE_NOTE_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case SMVM_GET_PRIVATE_NOTE_FAIL:
      return { loading: false, error: action.payload };
    case SMVM_GET_PRIVATE_NOTE_RESET:
      return {};
    default:
      return state;
  }
};
